import { IMunicipio } from '@app/modules/parametrizacao/municipio/model/municipio.model';
import { IEntity } from 'viggo-sistemas-core-web';
import { IPais } from '../../parametrizacao/paises/model/pais.model';
import { TagsList } from '../../produto/model/produto.model';


/**
 * representa os contatos vindos do backend
 */
export interface IParceiroContato extends IEntity {
  contato: string;
  tag: string | string[];
  tags: TagsList[];
}

/**
 * interface que representa o endereço salvo no backend
 */
export interface IParceiroEndereco extends IEntity {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  municipio_id: string;
  cep: string;
  ponto_referencia: string;
  municipio: IMunicipio;
  pais_id?: string;
  pais?: IPais;
  municipio_nome?: string;
  municipio_sigla_uf?: string;
}

export interface IParceiro extends IEntity {
  domain_id: string;
  cpf_cnpj: string;
  nome_razao_social: string;
  rg_insc_est: string;
  apelido_nome_fantasia: string;
  enderecos: IParceiroEndereco[];
  contatos: IParceiroContato[];
  doc_estrangeiro?: string;
  pais_id?: string;
  pais?: IPais;
}

export class Parceiro implements IParceiro {
  domain_id: string;
  cpf_cnpj: string;
  nome_razao_social: string;
  rg_insc_est: string;
  apelido_nome_fantasia: string;
  enderecos: IParceiroEndereco[];
  contatos: IParceiroContato[];
  id: string;
  created_at: Date;
  created_by: string;
  updated_at: Date;
  updated_by: string;
  active: boolean;
  doc_estrangeiro?: string;
  tag?: string | string[];
  toString(): string {
    return this.nome_razao_social;
  }
}
